import React from 'react'
import { Badge } from 'maeng-daisyui'
import { Category as CategoryType } from '@/types/Literal'

type CategoryProps = {
  value: CategoryType
  items: CategoryType[]
  onClick: (category: CategoryType) => void
}

const Category = ({ value, items, onClick }: CategoryProps) => {
  const handleClick = (category: CategoryType) => () => {
    onClick(category)
  }
  return (
    <div className="flex flex-wrap gap-4 justify-center w-full max-w-[500px] mt-8 mb-16 mx-auto">
      {items.map((category) => (
        <Badge
          className="border border-solid border-gray-100 rounded-lg shadow-md hover:cursor-pointer"
          color="primary"
          size="lg"
          outlined={value !== category}
          key={category}
          onClick={handleClick(category)}
        >
          <span className="font-semibold text-xs">{category}</span>
        </Badge>
      ))}
    </div>
  )
}

export default Category
